export enum JobType {
    LineGraph = 1,
    Spectrogram = 2,
    Historical = 4,
    BudgetSpectrogram = 8,
    BranchingAnalyse = 16,
    All = ~0
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/jobType.ts